<template>
  <div class="tab-pane" role="tabpanel" aria-labelledby="home-tab">
    <div class="row mb-3 mt-3">
      <div class="col-md-3">
        <b-button-group>
          <b-button variant="outline-danger">
            <input
              v-model="selectAll"
              type="checkbox"
              @change="selectItemAll(selectAll)"
            />
          </b-button>
          <b-button
            variant="outline-danger"
            type="button"
            :disabled="recordIds.length == 0"
            @click="multiDelete" v-if="$role=='super_admin'"
          >
            <i class="fa fa-trash" />
            {{ $t("site.bulk_delete") }}
          </b-button>
        </b-button-group>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <input
            v-model="search"
            type="text"
            autofocus
            class="form-control"
            :placeholder="$t(`site.search`)"
            @input="(val) => searchChange(val)"
          />
        </div>
      </div>
      <div class="col-3">
        <div class="float-md-right pt-1">
          <span class="text-muted text-small mr-1 mb-2">
            {{ from }}:{{ to }}
          </span>

          <b-dropdown
            id="ddown2"
            right
            :text="`${perPage}`"
            variant="outline-warning"
            size="xs"
          >
            <b-dropdown-item
              v-for="(size, index) in [5, 10, 20, 50, 100]"
              :key="index"
              @click="changePageSize(size)"
            >
              {{ size }}
            </b-dropdown-item>
          </b-dropdown>
          <span class="text-muted mr-1 mb-2"> of {{ total }}</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 overflow-auto">
        <b-table :stacked="($mobile==1)" 
          ref="table"
          class="vuetable"
          sort-by="id"
          sort-desc.sync="false"
          :current-page="currentPage"
          :fields="bootstrapTable.fields"
          :items="dataProvider"
        >
          <template #cell(checkbox)="data">
            <label class="kt-checkbox kt-checkbox--single kt-checkbox--solid">
              <input
                v-model="recordIds"
                type="checkbox"
                :value="data.item.id"
                @change="selectItem(data)"
              />
              <span />
            </label>
          </template>
          <template #cell(program_type)="data">
            {{ $t(`edu_programs.${data.item.program_type}`) }}
          </template>
          <template #cell(edu_season_id)="data">
            {{ data.item.edu_season.name }}
          </template>
          <template #cell(program_list_id)="data">
            {{ data.item.program_list.name }}
          </template>

          <template #cell(subscription_type)="data">
            <b-badge
              variant="success"
              class="badge-glow"
              v-if="data.item.subscription_type == 'free'"
            >
              {{ $t(`edu_programs.${data.item.subscription_type}`) }}
            </b-badge>
            <b-badge
              variant="success"
              class="badge-glow"
              v-if="data.item.subscription_type == 'paid'"
            >
              {{ $t(`edu_programs.${data.item.subscription_type}`) }}
            </b-badge>
          </template>

          <!-- data[0].program_list.name -->
          <template #cell(edit)="data">
            <button
              class="btn btn-icon btn-warning btn-icon"
              @click="editItem(data)"
            >
              <i class="fa fa-edit" />
            </button>
            <button
              class="btn btn-icon btn-danger btn-icon"
               @click="deleteItem(data)" v-if="$role=='super_admin'"
            >
              <i class="fa fa-trash" />
            </button>

            <b-button
              class="btn-icon"
              :to="{
                name: 'EduCourseProgramsSetting',
                params: { eduProgramId: data.item.id },
              }"
            >
              <i class="fas fa-cogs"></i>
            </b-button>
          </template>
          <template #cell(students)="data">
            <b-button
              v-b-modal.modal-info
              variant="outline-info"
              @click="student(data.item)"
            >
              {{ $t("students.students") }}
            </b-button>
          </template>
        </b-table>
        <b-spinner v-if="load" type="grow" label="Loading..."  class="loading" />

        <hr />
        <b-pagination
          v-model="currentPage"
          align="right"
          class="dataTables_paginate paging_simple_numbers pagination-warning"
          :total-rows="totalRows"
          :per-page="perPage"
        >
          <template v-slot:next-text>
            <i class="fas fa-angle-left" />
          </template>
          <template v-slot:prev-text>
            <i class="fas fa-angle-right" />
          </template>
          <template v-slot:first-text>
            <i class="fas fa-step-forward" />
          </template>
          <template v-slot:last-text>
            <i class="fas fa-step-backward" />
          </template>
        </b-pagination>

        <!-- end of table -->
      </div>
      <!-- end of col -->
    </div>
    <b-modal
      id="modal-info"
      ok-only
      ok-variant="info"
      modal-class="modal-info"
      centered
      size="lg"
      :title="title"
    >
      <b-table :stacked="($mobile==1)"  :items="users" :fields="userfields">
        <template #cell(edit)="data">
          <b-form-checkbox
            checked="true"
            class="custom-control-success"
            name="check-button"
            v-model="data.item.pivot.status"
            value="approved"
            switch
            @change="activation(data.item)"
          >
            <span class="switch-icon-left">
              <feather-icon icon="CheckIcon" />
            </span>
            <span class="switch-icon-right">
              <feather-icon icon="XIcon" />
            </span>
          </b-form-checkbox>
        </template>
      </b-table>

      <!-- <b-spinner v-else type="grow" label="Loading..."  class="loading" /> -->
    </b-modal>
  </div>
</template>

<script>
import controller from "../../../../Controllers/EduProgramsController";
import config from "../../../../config/config";
import UsersListFilters from "./UsersListFilters.vue";
export default {
  name: "EduProgramsDataTable",
  props: ["items", "editItem"],
  components: {
    UsersListFilters,
  },
  data() {
    return {
      filters: {},
      bootstrapTable: {
        selected: [],
        selectMode: "multi",
        fields: [
          { key: "checkbox", label: "", sortable: false },
          {
            key: "name",
            label: this.$i18n.t("edu_programs.name"),
            sortable: true,
          }, //

          {
            key: "program_list_id",
            label: this.$i18n.t("program_lists.program_list"),
            sortable: true,
          }, //

          {
            key: "subscription_type",
            label: this.$i18n.t("edu_programs.subscription_type"),
            sortable: true,
          },
          //students
          {
            key: "students",
            label: this.$i18n.t("students.students"),
            sortable: true,
          },
          { key: "edit", label: this.$i18n.t("site.action"), sortable: false },
        ],
      },
      data: {},
      selectAll: false,
      
      currentPage: 1,
      select: [],
      page: 1,
      perPage: 5,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {},
      recordIds: [],
      userfields: [
        {
          key: "code",
          label: this.$i18n.t("students.academic_number"),
          sortable: true,
        },
        {
          key: "first_name",
          label: this.$i18n.t("students.first_name"),
          sortable: true,
        },
        {
          key: "last_name",
          label: this.$i18n.t("students.last_name"),
          sortable: true,
        },

        {
          key: "email",
          label: this.$i18n.t("users.email"),
          sortable: true,
        },
        { key: "edit", label: this.$i18n.t("site.action"), sortable: false },
      ],
      users: [],
    };
  },
  methods: {
    async activation(item) {
      //waiting_for_approval
      if (item.pivot.status != "approved") {
        item.pivot.status = "waiting_for_approval";
      }
      await new controller().EduProgramApproval({
        user_id: item.id,
        edu_program: item.pivot.edu_program_id,
        status: item.pivot.status,
      });
    },
    updates() {
      this.$refs.table.refresh();
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    async dataProvider(ctx) {
      this.load = true;
      this.params = ctx;
      const data = await new controller().GetAll(this.apiParamsConverter());
      this.currentPage = data.current_page;
      this.perPage = data.per_page;
      this.totalRows = data.total;
      this.from = data.from;
      this.to = data.to;
      this.total = data.total;
      this.data = data.data;
      this.load = false;
      return data.data;
    },
    apiParamsConverter() {
      const apiParams = { per_page: this.perPage };
      if (this.params.currentPage >= 1) {
        apiParams.page = this.params.currentPage;
      }
      if (this.params.sortBy && this.params.sortBy.length > 0) {
        apiParams.sort = `${this.params.sortBy}|${
          this.params.sortDesc ? "desc" : "asc"
        }`;
      }
      if (this.params.filter && this.params.filter.length > 0) {
        // Optional
      }
      if (this.search !== "") {
        apiParams.search = this.search;
      }
      //  type: 0,
      //   : 0,
      //   : 0,
      if (this.filters.type) {
        apiParams.type = this.filters.type;
      }

      if (this.filters.edu_seasonOption) {
        apiParams.type = this.filters.edu_seasonOption;
      }
      if (this.filters.program_listOption) {
        apiParams.type = this.filters.program_listOption;
      }
      apiParams.with = ["programList", "eduSeason", "students"];
      apiParams.filter = "is_course|1";
      return apiParams;
    },
    student(item) {
      // console.log();
      this.users = item.students;
    },
    changePageSize(perPage) {
      this.page = 1;
      this.perPage = perPage;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    searchChange() {
      if (this.search.length == 0) {
        this.dataProvider(this.params);
        this.$refs.table.refresh();
      }
      if (this.search.length < 2) return;
      this.page = 1;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    selectItemAll(select) {
      this.recordIds = [];
      if (select) {
        this.data.forEach((element) => {
          this.recordIds.push(element.id);
        });
      }
    },
    deleteItem(data) {
      new controller().Delete(data.item.id, [], this.$refs.table);
    },
    multiDelete() {
      new controller().Delete(0, this.recordIds, this.$refs.table);
    },
  },
};
</script>
